import api from '../base';
import { CrossDockTracking, CrossDockTrackingRequest, CrossDockTrackingResponse } from './crossDockTrackingTypes';
import { mockCrossDockTracking, mockSaveCrossDockTrackingsResponse } from './crossDockTrackingMocks';

const BASE_PATH = 'management/cross-dock-trackings';

export async function getCrossDockTracking(
  id: number,
  signal?: AbortSignal,
): Promise<CrossDockTracking> {
  const response = await api.get<CrossDockTracking>(
    `${BASE_PATH}/${id}`,
    { signal },
  );
  return response.data;
}

api.mock
  .onGet(new RegExp(`${BASE_PATH}/\\d+`))
  .reply(200, mockCrossDockTracking);

export async function saveCrossDockTrackings(
  request: CrossDockTrackingRequest,
  signal?: AbortSignal,
): Promise<CrossDockTrackingResponse> {
  const response = await api.put<CrossDockTrackingResponse>(
    BASE_PATH,
    request,
    { signal },
  );
  return response.data;
}

api.mock
  .onPut(BASE_PATH)
  .reply(200, mockSaveCrossDockTrackingsResponse);
